(function () {
  'use strict';

  if (!/^en(?:-|$)/i.test(document.documentElement.lang || '')) return;

  window.EVM_EN_UI = { version: '2026-08-25.1' };
  document.documentElement.setAttribute('data-evm-en-ui', '2026-08-25.1');

  var EXACT = {
    // Shared navigation and account UI.
    'Główna': 'Home',
    'Szukaj': 'Search',
    'Zaloguj się': 'Sign in',
    'Wybierz Pojazd': 'Select vehicle',
    'wybierz pojazd': 'select vehicle',
    'Akcesoria': 'Accessories',
    'Marka': 'Make',
    'Zmień pojazd': 'Change vehicle',
    'zmień pojazd': 'change vehicle',
    'Usuń filtry': 'Clear filters',
    'USUŃ FILTRY': 'CLEAR FILTERS',
    'Powrót': 'Back',
    'Czytaj więcej': 'Read more',
    'Zobacz wszystko': 'View all',
    'Pokaż więcej': 'Show more',
    'Ukryj': 'Hide',
    'Powiększ podgląd': 'Enlarge preview',
    'Zwiń podgląd': 'Collapse preview',
    'Sekcje produktu': 'Product sections',
    'Poprzednie zdjęcie': 'Previous image',
    'Następne zdjęcie': 'Next image',
    'Otwórz czat': 'Open chat',
    'Dostawa i płatność': 'Delivery and payment',
    'DOSTAWA I PŁATNOŚĆ': 'DELIVERY AND PAYMENT',
    'Wyceń zestaw': 'Configure your set',
    'WYCEŃ ZESTAW': 'CONFIGURE YOUR SET',
    'Wyceń': 'Get a quote',
    'WYCEŃ': 'GET A QUOTE',
    'Wybierz opcję': 'Select an option',
    'Proszę wybrać opcję': 'Please select an option',
    'Imię i Nazwisko': 'Full name',
    'Imię i Nazwisko ': 'Full name',
    'Zgadzam się z': 'I agree to the',
    'polityką prywatności': 'Privacy Policy',
    'regulaminem': 'Terms and Conditions',
    'Musisz zaakceptować politykę prywatności i regulamin.': 'Please accept the Privacy Policy and Terms and Conditions.',
    'Email jest nieprawidłowy.': 'Please enter a valid email address.',
    'Phone jest nieprawidłowy.': 'Please enter a valid phone number.',
    'Dalej': 'Continue',
    'DALEJ': 'CONTINUE',
    'Gotowe': 'Done',
    'GOTOWE': 'DONE',
    'Zapisywanie...': 'Saving…',
    'ZAPISYWANIE...': 'SAVING…',
    'ZAPISYWANIE…': 'SAVING…',

    // Homepage.
    'ZAMÓW MATĘ': 'ORDER CAR MATS',
    'ZAMÓW ORGANIZER': 'ORDER AN ORGANIZER',
    'Rozwiązania na co dzień': 'Everyday solutions',
    'Inowacyjne 3D dywaniki z rantami': 'Innovative 3D mats with raised edges',
    'Szyjemy na miarę – dokładnie dla Twojego auta': 'Made to measure — precisely for your vehicle',
    '195 kolorów. Zaprojektuj swoje wnętrze': '195 colours. Design your interior',
    'Wyprodukowano z dumą w Polsce': 'Proudly made in Poland',
    'TYSIĄCE': 'THOUSANDS OF',
    'Zadowolonych kierowców': 'Satisfied drivers',
    'Dostępne modele': 'Available models',
    'Wysyłka do wielu krajów': 'Shipping to many countries',
    'SPRAWDŹ SWÓJ ZESTAW': 'CHECK YOUR SET',
    'MATA DO BAGAŻNIKA': 'TRUNK MAT',
    'ORGANIZER XL | M': 'XL | M ORGANIZER',
    'ZOBACZ RÓŻNICĘ I WYBIERZ SWÓJ ZESTAW': 'SEE THE DIFFERENCE AND CHOOSE YOUR SET',
    'EVAMATS BEZ RANTÓW': 'EVAMATS WITHOUT EDGES',
    'EVAMATS Z RANTAMI': 'EVAMATS WITH EDGES',
    'BESTSELLERY': 'BESTSELLERS',
    'Zobacz realizacje:': 'View projects:',
    'ZAINSPIRUJ SIĘ!': 'GET INSPIRED!',
    'ZOBACZ GALERIĘ NASZYCH REALIZACJI': 'VIEW OUR PROJECT GALLERY',
    'Dywaniki samochodowe EVAMATS – FAQ': 'EVAMATS Car Mats — FAQ',
    'Dopasowanie i pokrycie podłogi': 'Fit and floor coverage',
    'Cechy i trwałość materiału': 'Material features and durability',
    'Użytkowanie i konserwacja': 'Use and care',
    'Zamówienie i dostawa': 'Ordering and delivery',

    // Cart and cart recommendations.
    'Może ci się spodobać': 'You may also like',
    'Popularne': 'Popular',
    'Ochrona': 'Protection',
    'Organizery': 'Organizers',
    'POLECANE': 'RECOMMENDED',
    'Polecane': 'Recommended',
    'Pełna kompatybilność': 'Fully compatible',
    'Rok produkcji': 'Model year',
    'Rok produkcji:': 'Model year:',
    'Dane pojazdu': 'Vehicle details',
    'Rabat': 'Discount',
    'RODZAJ': 'TYPE',
    'Rodzaj': 'Type',
    'WARIANT': 'VARIANT',
    'Wariant': 'Variant',
    'RODZAJ DYWANIKÓW': 'MAT TYPE',
    'KOMPLET': 'SET',
    'Komplet': 'Set',
    'ZESTAW': 'SET',
    'Zestaw': 'Set',
    'KSZTAŁT': 'PATTERN',
    'Kształt': 'Pattern',
    'KSZTAŁT KOMÓREK': 'CELL PATTERN',
    'Kształt komórek': 'Cell pattern',
    'Ksztalt komorek': 'Cell pattern',
    'MATERIAŁ': 'MAT COLOUR',
    'MATERIAL': 'MAT COLOUR',
    'Materiał': 'Mat colour',
    'KOLOR MATERIAŁU': 'MAT COLOUR',
    'Kolor materiału': 'Mat colour',
    'OBSZYCIE': 'TRIM COLOUR',
    'Obszycie': 'Trim colour',
    'KOLOR OBSZYCIA': 'TRIM COLOUR',
    'Kolor obszycia': 'Trim colour',
    'PODPIĘTKA I DODATKI': 'HEEL PAD AND EXTRAS',
    'Podpiętka i dodatki': 'Heel pad and extras',
    'PODPIĘTKA': 'HEEL PAD',
    'Podpiętka': 'Heel pad',
    'Dobierz do kompletu': 'Add to your set',
    'Wzmocnione Szwy Premium': 'Reinforced premium stitching',
    'Więcej dodatków': 'More extras',
    'Dodatki': 'Extras',
    'DODATKI': 'EXTRAS',
    'Opakowanie, ochrona, organizer': 'Packaging, protection and organiser',
    'Edytuj konfigurację': 'Edit configuration',
    'Edytuj konfiguracje': 'Edit configuration',
    'Edytuj konfigurację produktu': 'Edit product configuration',
    'Nie wybrano': 'Not selected',
    'Konfiguracja po rabacie': 'Configuration after discount',
    'RAZEM ZA KONFIGURACJĘ': 'CONFIGURATION TOTAL',
    'Razem za konfigurację': 'Configuration total',
    'ANULUJ': 'CANCEL',
    'Anuluj': 'Cancel',
    'ZAPISZ ZMIANY': 'SAVE CHANGES',
    'Zapisz zmiany': 'Save changes',
    'Zamówienie gotowe. Możesz przejść do dostawy i płatności.': 'Your order is ready. You can continue to delivery and payment.',
    'Zamówienie gotowe.': 'Your order is ready.',
    'Możesz przejść do dostawy i płatności.': 'You can continue to delivery and payment.',
    'Brakuje': '',
    'do darmowej dostawy': 'left to qualify for free delivery',
    'Twój koszyk kwalifikuje się do darmowej dostawy': 'Your cart qualifies for free delivery',
    'Rozlane zostaje na macie': 'Spills stay on the mat',
    'Czyszczenie w 5 sekund': 'Clean in 5 seconds',
    'Oszczędzasz': 'You save',
    'Dostawa': 'Delivery',
    'naliczana w kasie': 'calculated at checkout',
    'Razem': 'Total',
    'Zgadzam się z polityką prywatności i regulaminem.': 'I agree to the Privacy Policy and Terms and Conditions.',
    'Zgadzam się z': 'I agree to the',
    'polityką prywatności': 'Privacy Policy',
    'regulaminem': 'Terms and Conditions',
    '(max 3 kody rabatowe na zamówienie)': '(maximum 3 discount codes per order)',
    'Tunel': 'Centre tunnel',
    'W KOMPLECIE': 'INCLUDED',
    'Zamontowana (+10.00 zł)': 'Installed (+10.00 zł)',
    'Niezamontowana': 'Not installed',
    'Fitting': 'Installation',
    'Not fitted': 'Not installed',
    'Fitted (+10.00 zł)': 'Installed (+10.00 zł)',
    'Cofnij': 'Back',
    'Usuń': 'Remove',
    'Zamknij': 'Close',
    'Podsumowanie': 'Summary',
    'Samochód': 'Vehicle',
    'Pozycja': 'Item',
    'Akcesorium': 'Accessory',
    'Dodatkowe opcje': 'Additional options',
    'Opcjonalnie': 'Optional',
    'Dodaj': 'Add',
    'Zmień': 'Change',
    'Produkt został usunięty': 'Product removed',
    'Usunięto konfigurację i powiązane dodatki': 'Configuration and linked extras removed',
    'Przywracam…': 'Restoring…',
    'PRZYWRACAM…': 'RESTORING…',

    // Configurator controls and values.
    'KROK 1 Z 5': 'STEP 1 OF 5',
    'KROK 2 Z 5': 'STEP 2 OF 5',
    'KROK 3 Z 5': 'STEP 3 OF 5',
    'KROK 4 Z 5': 'STEP 4 OF 5',
    'KROK 5 Z 5': 'STEP 5 OF 5',
    'Wybierz rodzaj i zestaw mat:': 'Choose the mat type and set:',
    'Wybierz wykończenie i komplet dopasowany do Twojego auta.': 'Choose the finish and set tailored to your car.',
    'Rodzaj dywaników': 'Mat type',
    '3D BEZ RANTÓW': '3D WITHOUT EDGES',
    '3D Z RANTAMI': '3D WITH EDGES',
    '3D bez rantów': '3D without edges',
    '3D z rantami': '3D with edges',
    'Przód': 'Front',
    'Tył': 'Rear',
    'Dywanik kierowcy': "Driver's mat",
    'Dywanik Kierowcy': "Driver's mat",
    'Mata do bagażnika': 'Trunk mat',
    'Mata Do Bagażnika': 'Trunk mat',
    'Przód + tył': 'Front + rear',
    'Przód + Tył': 'Front + rear',
    'Przód + tył + bagażnik': 'Front + rear + trunk',
    'Przód + Tył + Bagażnik': 'Front + rear + trunk',
    'Przód + Tył / Czarny': 'Front + rear / Black',
    'Przód + Tył / Kawowy': 'Front + rear / Coffee',
    'Przód + tył / Czarny': 'Front + rear / Black',
    'Przód + tył / Kawowy': 'Front + rear / Coffee',
    'Romby': 'Diamond',
    'ROMBY': 'DIAMOND',
    'Plaster miodu': 'Honeycomb',
    'Plastry miodu': 'Honeycomb',
    'Plastry Miodu': 'Honeycomb',
    'PLASTRY MIODU': 'HONEYCOMB',
    'plastry miodu': 'honeycomb',
    'romby': 'diamond',
    'Kropla': 'Droplet',
    'Kropla (+100 Zł)': 'Droplet (+100 zł)',
    'Krople': 'Droplets',
    'KROPLE': 'DROPLETS',
    'DROPLETS (+100 ZŁ)': 'DROPLETS (+100 zł)',
    'Czarny': 'Black',
    'Brązowy': 'Brown',
    'Beżowy': 'Beige',
    'Ciemnoszary': 'Dark grey',
    'Czerwony': 'Red',
    'Niebieski': 'Blue',
    'Biały': 'White',
    'Szary': 'Grey',
    'Kawowy': 'Coffee',
    'Bordowy': 'Maroon',
    'BORDOWY': 'MAROON',
    'Granatowy': 'Navy Blue',
    'GRANATOWY': 'NAVY BLUE',
    'Jasnobeżowy': 'Light Beige',
    'JASNOBEŻOWY': 'LIGHT BEIGE',
    'Jasnozielony': 'Light Green',
    'JASNOZIELONY': 'LIGHT GREEN',
    'Kość słoniowa': 'Ivory',
    'KOŚĆ SŁONIOWA': 'IVORY',
    'Różowy': 'Pink',
    'RÓŻOWY': 'PINK',
    'Malinowy': 'Raspberry',
    'MALINOWY': 'RASPBERRY',
    'Miedziany': 'Copper',
    'MIEDZIANY': 'COPPER',
    'Jasnoszary': 'Light Grey',
    'JASNOSZARY': 'LIGHT GREY',
    'Pomarańczowy': 'Orange',
    'Zielony': 'Green',
    'Fioletowy': 'Purple',
    'Żółty': 'Yellow',
    'Uwaga mata do bagażnika': 'Important: boot mat',
    'Podgląd konfiguracji dywanika': 'Mat configuration preview',
    'Podgląd konfiguracji': 'Configuration preview',
    'Rozmiar': 'Size',
    'ROZMIAR': 'SIZE',
    'Podgląd konfiguracji na żywo — kształt i kolory aktualizują się od razu.': 'Live configuration preview — the shape and colours update instantly.',
    'PODPIĘTKI EVA': 'EVA HEEL PADS',
    'Podpiętki EVA': 'EVA heel pads',
    'Order notes (opcjonalnie)': 'Order notes (optional)',
    'Zamawiaj bez obaw.': 'Order with confidence.',
    'They talk about us': 'What customers say',
    'Uniwersalne dywaniki EVA - do samodzielnego docięcia': 'Universal EVA Car Mats — Trim to Fit',
    'Rozlana kawa leżąca na dywaniku EVAMATS': 'Spilled coffee contained on an EVAMATS car mat',
    'Podgląd Wyświetlany dywanik służy wyłącznie do podglądu konfiguracji — nie jest zdjęciem gotowego produktu.': 'The mat shown is a configuration preview only — it is not a photo of the finished product.',

    // Product benefits.
    'Oryginalne dywaniki EVAMATS — nowoczesna ochrona wnętrza auta. Wykrój przygotowany pod konkretny model, struktura komórkowa zatrzymuje błoto, piasek i wodę, a obszycie chroni tapicerkę wzdłuż każdej linii.': 'Original EVAMATS car mats provide modern protection for your vehicle interior. Each pattern is tailored to a specific model, the cellular structure traps mud, sand and water, and the edge trim protects the upholstery along every contour.',
    'Oryginalne dywaniki EVAMATS — nowoczesna ochrona wnętrza auta': 'Original EVAMATS car mats — modern protection for your vehicle interior',
    'Wykrój przygotowany pod konkretny model, struktura komórkowa zatrzymuje błoto, piasek i wodę, a obszycie chroni tapicerkę wzdłuż każdej linii.': 'Each pattern is tailored to a specific model, the cellular structure traps mud, sand and water, and the edge trim protects the upholstery along every contour.',
    '100% odporność na wilgoć': '100% moisture-resistant',
    'Woda i błoto zostają w komórkach, nie na podłodze.': 'Water and mud stay in the cells, not on the floor.',
    'Czyszczenie w kilka sekund': 'Clean in seconds',
    'Wystarczy wytrzepać lub spłukać wodą.': 'Simply shake them out or rinse with water.',
    'Bezpieczne dla zdrowia i zwierząt': 'Safe for people and pets',
    'Materiał EVA bez zapachu, w 100% z recyklingu.': 'Odour-free EVA material made from 100% recycled material.',
    'Dopasowanie do 95% podłogi': 'Covers up to 95% of the floor',
    'Odporność −50°C do +50°C': 'Resistant from −50°C to +50°C',
    'Odporność -50°C do +50°C': 'Resistant from −50°C to +50°C',
    'Nie twardnieją zimą, nie odkształcają się latem.': 'They stay flexible in winter and retain their shape in summer.',
    'WYBIERZ NAJLEPSZĄ OCHRONĘ DLA SWOJEGO SAMOCHODU Z EVAMATS!': 'CHOOSE THE BEST PROTECTION FOR YOUR CAR WITH EVAMATS!',
    'Dywaniki EVAMATS to produkt stworzony z myślą o trwałości, estetyce i funkcjonalności. Dzięki nim podróże staną się jeszcze bardziej komfortowe, a wnętrze Twojego auta zawsze będzie wyglądać jak nowe!': 'EVAMATS car mats combine durability, clean design and everyday practicality. They make every journey more comfortable while helping your vehicle interior stay looking like new.',
    "EVAMATS are a product created with durability, aesthetics and functionality in mind. Thanks to them, journeys will become even more comfortable, and your car's interior will always look like new!": 'EVAMATS car mats combine durability, clean design and everyday practicality. They make every journey more comfortable while helping your vehicle interior stay looking like new.',
    '🛒 Zamów teraz i przekonaj się, jak wyjątkowe mogą być dywaniki samochodowe EVAMATS!': '🛒 Order now and discover how much difference EVAMATS car mats can make.',
    'Zamów teraz i przekonaj się, jak wyjątkowe mogą być dywaniki samochodowe EVAMATS!': 'Order now and discover how much difference EVAMATS car mats can make.',
    'Order now and see how exceptional EVAMATS car mats can be!': 'Order now and discover how much difference EVAMATS car mats can make.',

    // Product benefit image sections.
    '1. JĘZOR – DODATKOWA OCHRONA POD PEDAŁAMI I FOTELEM': '1. FOOTREST — EXTRA PROTECTION UNDER THE PEDALS AND SEAT',
    '1. JĘZOR – DODATKOWA OCHRONA POD PEDAŁAMI I FOTELEM ': '1. FOOTREST — EXTRA PROTECTION UNDER THE PEDALS AND SEAT',
    'Specjalnie zaprojektowany jęzor skutecznie chroni najbardziej narażone na zużycie miejsca, takie jak obszar odpoczynku lewej nogi.': 'The specially designed footrest effectively protects the areas most exposed to wear, including the left-foot rest area.',
    'Precyzyjne dopasowanie do kształtu auta zwiększa komfort jazdy i estetykę wnętrza.': 'Its precise fit follows the shape of the vehicle, improving driving comfort and the appearance of the interior.',
    'Uwaga: Wersja 3D z jęzorem nie jest możliwa dla każdego modelu.': 'Please note: the 3D version with a footrest is not available for every model.',
    'Prosimy sprawdzić zdjęcie główne – przedstawia ono przykładowy wygląd dywaników dla danego samochodu.': 'Please check the main product image, which shows an example of how the mats look for this vehicle.',
    '2. IDEALNE DOPASOWANIE': '2. PRECISE FIT',
    '3. RANTY DO 7 CM': '3. EDGES UP TO 7 CM',
    '4. MOCOWANIA DO WSZYSTKICH MAREK': '4. FASTENERS FOR ALL CAR BRANDS',
    '5. OSŁONA TUNELU': '5. CENTRE-TUNNEL COVER',
    '6. RZEPIKI W NAROŻNIKACH': '6. CORNER FASTENERS',
    '7. OBSZYCIE I WZMOCNIONA NIĆ': '7. EDGE TRIM AND REINFORCED THREAD',
    '8. GRUBOŚĆ MATY 10 MM': '8. 10 MM MAT THICKNESS',
    '9. KOMÓRKI O GŁĘBOKOŚCI 7 MM': '9. 7 MM DEEP CELLS',

    // Product recommendations.
    'Uniwersalna poduszka na fotel': 'Universal seat cushion',
    'Uniwersalny pokrowiec na kierownicę włókno węglowe': 'Universal carbon-fibre steering wheel cover',
    'Uniwersalne Pokrowce 5D Luksusowe': 'Luxury 5D universal seat covers',
    'Uniwersalne Pokrowce 2D Classic': 'Classic 2D universal seat covers',
    'Miękka Rękawica do Mycia Samochodu': 'Soft car-wash mitt',
    'Ściereczka z Mikrofibry do samochodu duża 60x90': 'Large car microfibre cloth 60 × 90 cm',
    'Fabryczna Ochrona Anti-Dirt': 'Factory Anti-Dirt Protection',
    'DODAJ DO KOSZYKA': 'ADD TO CART',

    // Cross-sell and comparison blocks.
    'INNY MATERIAŁ?': 'ANOTHER MATERIAL?',
    'Inny materiał?': 'Another material?',
    'Te same dywaniki, inny charakter': 'The same precise fit, a different character',
    'Te same dywaniki,': 'The same precise fit,',
    'inny charakter': 'a different character',
    'Dane techniczne': 'Technical specifications',
    'DANE TECHNICZNE': 'TECHNICAL SPECIFICATIONS',
    'Poznaj wszystkie nasze linie — uniwersalne EVA, welur i ekoskórę. Dopasowane tak samo precyzyjnie pod Twój model.': 'Explore all our ranges — universal EVA, velour and eco-leather. Each one is tailored just as precisely to your model.',
    'EVA': 'EVA',
    'WELUR': 'VELOUR',
    'EKOSKÓRA': 'ECO-LEATHER',
    'WKRÓTCE': 'COMING SOON',
    'Wkrótce': 'Coming soon',
    'Uniwersalne dywaniki EVA': 'Universal EVA mats',
    'Welurowe dywaniki Premium': 'Premium velour mats',
    'Welurowe dywaniki z czerwoną lamówką': 'Premium velour mats with red trim',
    'Dywaniki z eko-skóry 3D': '3D eco-leather mats',
    'Dywaniki z eko-skóry 3D pikowane': 'Quilted 3D eco-leather mats',
    'W 100% odporne na wilgoć': '100% moisture-resistant',
    'Zatrzymują wodę, błoto i piasek': 'Trap water, mud and sand',
    'Uniwersalne — dopasujesz sam': 'Universal — trim them to fit',
    'Miękki i elegancki materiał': 'Soft, elegant material',
    'Komfort i wyciszenie wnętrza': 'Comfort and a quieter interior',
    'Łatwe w czyszczeniu': 'Easy to clean',
    'Wodoodporne i odporne na zabrudzenia': 'Water-resistant and dirt-resistant',
    'Łatwe w utrzymaniu czystości': 'Easy to keep clean',
    'Ekskluzywny wygląd wnętrza': 'A premium interior look',
    'Zobacz dywaniki EVA': 'View EVA mats',
    'Już w przygotowaniu': 'Coming soon',
    'Zobacz eko skórę': 'View eco-leather mats',
    'Dlaczego warto wybrać dywaniki': 'Why choose',
    'Porównaj sam': 'See the difference',
    'Dywaniki EVA': 'EVA mats',
    'Gumowe': 'Rubber',
    'Welurowe': 'Velour',

    // Blog and rare-car sections.
    'Nasze realizacje': 'Our projects',
    'PORÓWNANIE DYWANIKÓW SAMOCHODOWYCH EVA I GUMOWY...': 'EVA VS RUBBER CAR MATS: A PRACTICAL COMPARISON',
    'Porównanie dywaników samochodowych EVA i gumowych - co wybrać?': 'EVA vs rubber car mats — which should you choose?',
    'Porównanie dywaników samochodowych EVA i gumowy...': 'EVA vs rubber car mats: a practical comparison',
    'JAKIE DYWANIKI SAMOCHODOWE SPRAWDZĄ SIĘ ZIMĄ?': 'WHICH CAR MATS WORK BEST IN WINTER?',
    'Jakie dywaniki samochodowe sprawdzą się zimą?': 'Which car mats work best in winter?',
    'JAK WŁAŚCIWIE DBAĆ O DYWANIKI EVA W SAMOCHODZIE': 'HOW TO CARE FOR EVA CAR MATS',
    'Jak właściwie dbać o dywaniki EVA w samochodzie': 'How to care for EVA car mats',
    'Dowiedz się, jak łatwo i skutecznie czyścić oraz pielęgnować dywaniki EVA, aby służyły Ci jak najdłużej i wyglądały jak nowe.': 'Learn how to clean and care for EVA mats so they last as long as possible and continue to look like new.',
    'Zastanawiasz się, co lepsze - dywaniki EVA czy gumowe? Sprawdź porównanie i wybierz idealne rozwiązanie do swojego auta.': 'Wondering whether EVA or rubber mats are better? Compare them and choose the right solution for your car.',
    'Szukasz dywaników samochodowych na zimę? Sprawdź, jakie modele najlepiej chronią wnętrze auta przed śniegiem, błotem i solą drogową.': 'Looking for winter car mats? See which models best protect your interior from snow, mud and road salt.',
    'WSZYSTKIE POSTY': 'ALL POSTS',
    'Wszystkie posty': 'All posts',
    '“POSIADASZ RZADKI SAMOCHÓD? “': '“DO YOU OWN A RARE CAR?”',
    '“Posiadasz rzadki samochód? “': '“Do you own a rare car?”',
    '„POSIADASZ RZADKI SAMOCHÓD?”': '“DO YOU OWN A RARE CAR?”',
    'Nie możesz znaleźć dywaników do Swojego wyjątkowego auta?': 'Can’t find mats for your unique vehicle?',
    'Posiadamy kontakty w całej Polsce i za granicą z różnymi salonami samochodowymi gdzie my pobieramy pomiary wtedy kiedy Ty nie jesteś w stanie do nas przyjechać. Do każdego pomierzenia podchodzimy z taką doskonałością, z jaką zegarmistrz składa zegarek.': 'We work with dealerships throughout Poland and abroad, so we can take precise measurements even when you cannot bring the vehicle to us. Every measurement is approached with the same care and precision as a watchmaker assembling a timepiece.',
    'Wypełnij ten formularz i my zrealizujemy indywidualnie dopasowane dywaniki do Twojego samochodu.': 'Complete the form and we will create a set of mats tailored individually to your vehicle.',
    'We have contacts all over Britain and abroad with various car showrooms where we take measurements when you are not able to come to us. We approach every measurement with the same perfection as a watchmaker assembling a watch.': 'We work with dealerships throughout Poland and abroad, so we can take precise measurements even when you cannot bring the vehicle to us. Every measurement is approached with the same care and precision as a watchmaker assembling a timepiece.',
    'ZAMÓWIENIE INDYWIDUALNE': 'CUSTOM ORDER',
    'Zamówienie indywidualne': 'Custom order',

    // Contact page.
    'Skontaktuj się': 'Contact us',
    'Mam pytanie? Skontaktuj się z nami!': 'Have a question? Contact us!',
    'Adres siedziby:': 'Registered office:',
    'Telefon kontaktowy': 'Contact phone',
    'Informacje ogólne i obsługa klienta': 'General enquiries and customer service',
    'Zgłoszenia reklamacyjne i zwroty': 'Complaints and returns',
    'Kontakt z działem produkcji': 'Production department',
    'Kontakt z działem produkcj': 'Production department',

    // About page.
    'O NAS': 'ABOUT US',
    'O nas': 'About us',
    'Twój komfort ma znaczenie': 'Your comfort matters',
    'EVAMATS to nie tylko dywaniki samochodowe. To innowacyjne rozwiązania, które połączą styl, trwałość i ekologiczne materiały. Nasz materiał jest ekologiczny, co oznacza, że dbasz nie tylko o swoje auto, ale również o środowisko.': 'EVAMATS is more than car mats. It is an innovative solution combining style, durability and eco-friendly materials, so you care for both your vehicle and the environment.',
    'EVAMATS powstał od podstaw — od ręcznej pracy i pełnego zaangażowania w każdy detal, po dopracowany system, który dziś wyznacza standard jakości.': 'EVAMATS was built from the ground up — from hands-on craftsmanship and attention to every detail to a refined system that sets today’s quality standard.',
    'To doświadczenie nauczyło nas jednego: produkt ma znaczenie tylko wtedy, gdy działa w codziennym użytkowaniu.': 'Experience has taught us one thing: a product matters only when it works in everyday use.',
    'Dlatego tworzymy dywaniki samochodowe, które są realnie dopasowane do auta i potrzeb kierowcy — z uwzględnieniem różnic konstrukcyjnych, warunków użytkowania i trwałości na lata. Każdy element ma swoją funkcję, a każdy etap produkcji podlega kontroli, bo końcowy efekt nie jest przypadkiem.': 'That is why we make car mats genuinely tailored to the vehicle and the driver — accounting for structural differences, real-world conditions and years of use. Every element has a purpose, and every production stage is inspected, because a great result is never accidental.',
    'Nie chodzi o sam produkt.': 'It is not only about the product.',
    'Chodzi o to, jak zmienia codzienne doświadczenie jazdy — więcej porządku, więcej wygody, mniej kompromisów.': 'It is about how it improves everyday driving — more order, more comfort and fewer compromises.',
    'Bo dla nas komfort kierowcy to nie dodatek.': 'For us, driver comfort is not an extra.',
    'To standard.': 'It is the standard.',
    '50k+ kierowców': '50k+ drivers',
    'Pomiary i szablony': 'Measurements and templates',
    'Cięcie CNC': 'CNC cutting',
    'Szycie i formowanie 3D': '3D stitching and shaping',
    'Pakowanie i wysyłka': 'Packing and shipping',
    'Precyzja zaczyna się od podstaw': 'Precision starts with the foundation',
    'Każdy model analizujemy indywidualnie — uwzględniając realne różnice konstrukcyjne.': 'We analyse every model individually, taking real structural differences into account.',
    'Szablony tworzymy na bazie rzeczywistych pomiarów, aby zapewnić idealne dopasowanie do konkretnego auta.': 'We create templates from real measurements to ensure a precise fit for each vehicle.',
    'Dokładność na poziomie technologii': 'Technology-driven accuracy',
    'Korzystamy z precyzyjnych maszyn CNC, które zapewniają perfekcyjne odwzorowanie kształtu.': 'We use precision CNC machines to reproduce every shape accurately.',
    'Każde cięcie jest powtarzalne i dokładne — bez odchyleń i kompromisów.': 'Every cut is consistent and exact — with no deviations or compromises.',
    'Funkcja spotyka formę': 'Form meets function',
    'Obszycia i ranty nadają trwałość oraz estetykę.': 'Edge trim and raised edges add durability and a refined finish.',
    'Formowanie 3D sprawia, że dywanik idealnie przylega do podłogi i chroni wnętrze auta.': '3D shaping makes the mat follow the floor precisely and protect the vehicle interior.',
    'Każdy detal ma znaczenie': 'Every detail matters',
    'Każdy komplet przechodzi dokładną weryfikację.': 'Every set undergoes a thorough inspection.',
    'Sprawdzamy dopasowanie, jakość wykonania i wykończenie — zanim trafi do klienta.': 'We check the fit, workmanship and finish before the set reaches the customer.',
    'Gotowe do codziennego użytkowania': 'Ready for everyday use',
    'Bezpieczne pakowanie i sprawna logistyka.': 'Secure packaging and efficient logistics.',
    'Produkt dociera w idealnym stanie — gotowy, by od razu spełniać swoją funkcję.': 'Your product arrives in perfect condition, ready to use straight away.',
    'Jak to robimy?': 'How we make them',
    'Krok': 'Step',
    'Dopasowanie do modelu auta': 'Vehicle-specific fit',
    'Ręczne wykonanie': 'Handmade',
    'Kontrola jakości': 'Quality control',
    'Wysyłka': 'Shipping',
    'Jak działa struktura EVA — i dlaczego to robi różnicę': 'How EVA cell structure works — and why it makes a difference',
    'Dlaczego EVA to materiał, który zmienia komfort jazdy?': 'Why does EVA transform driving comfort?',
    'Zatrzymuje brud w komórkach': 'Traps dirt inside the cells',
    'Nie pozwala mu się rozprzestrzeniać': 'Stops dirt from spreading',
    'Nie chłonie wilgoci': 'Does not absorb moisture',
    'Ten sam materiał stosowany jest w:': 'The same material is used in:',
    'Woda? Żaden problem.': 'Water? No problem.',
    'EVA nie chłonie wilgoci.': 'EVA does not absorb moisture.',
    'Ekstremalne warunki?': 'Extreme conditions?',
    'EVA stworzona, by wytrzymać więcej.': 'EVA is made to withstand more.',
    'Testowana pod presją.': 'Tested under pressure.',
    'EVA nie zawodzi.': 'EVA performs when it matters.',
    'Jeśli EVA sprawdza się tam, gdzie liczy się wytrzymałość i komfort –': 'If EVA performs where durability and comfort matter —',
    'sprawdzi się również w Twoim aucie.': 'it will perform in your car too.',
    'Jeśli EVA sprawdza się tam, gdzie liczy się wytrzymałość i komfort – sprawdzi się również w Twoim aucie.': 'If EVA performs where durability and comfort matter, it will perform in your car too.',
    'Zobacz produkt': 'View product',
    'Nie chłonie wody': 'Does not absorb water',
    'brak wilgoci i zapachu': 'no moisture or odour',
    'Odporność na ścieranie': 'Abrasion-resistant',
    'wygląda dobrze przez lata': 'looks good for years',
    'Łatwe czyszczenie': 'Easy to clean',
    'wystarczy spłukać wodą': 'simply rinse with water',
    'Struktura antypoślizgowa': 'Non-slip structure',
    'brud zostaje na miejscu': 'keeps dirt in place',
    'Lekki i elastyczny': 'Lightweight and flexible',
    'idealnie dopasowuje się do auta': 'follows the vehicle floor precisely',
    'Co to oznacza dla Ciebie?': 'What does this mean for you?',
    'Gumowe vs EVAMATS 3D z Rantami': 'Rubber vs EVAMATS 3D with raised edges',
    'Welurowe vs EVAMATS 3D z Rantami': 'Velour vs EVAMATS 3D with raised edges',
    'Dywaniki EVA vs EVAMATS 3D z Rantami': 'EVA mats vs EVAMATS 3D with raised edges',
    'EVAMATS 3D z Rantami': 'EVAMATS 3D with raised edges',
    'Dywaniki EVAMATS': 'EVAMATS mats',
    'vs. Inni wykonawcy': 'vs other manufacturers',
    'Uzyskaj bezpłatną konsultację!': 'Get a free consultation!',
    'Chętnie pomożemy Ci dobrać odpowiednie rozwiązanie.': 'We will be happy to help you choose the right solution.',
    'Imię i nazwisko': 'Full name',
    'Komentarz (opcjonalnie)': 'Comment (optional)',
    'Twoja wiadomość…': 'Your message…',
    'Zostaw zapytanie': 'Send enquiry',
    'oraz': 'and',
    'Polityką prywatności': 'Privacy Policy',
    'Dziękujemy! Skontaktujemy się wkrótce.': 'Thank you! We will contact you shortly.',
    'Sprawdź pola i spróbuj ponownie.': 'Please check the fields and try again.',
    'Struktura': 'Structure',
    'Struktura zatrzymująca brud i wodę': 'A structure that traps dirt and water',
    'Dopasowanie': 'Fit',
    'Precyzyjne dopasowanie do modelu auta': 'Precisely tailored to the vehicle model',
    'Materiał': 'Material',
    'Wytrzymały materiał EVA odporny na zużycie': 'Durable, wear-resistant EVA material',
    'Rant': 'Raised edge',
    'Podwyższony rant chroni wnętrze auta': 'Raised edges protect the vehicle interior',
    'Czyszczenie': 'Cleaning',
    'Łatwe czyszczenie w kilka sekund': 'Easy to clean in seconds',
    'Właściciele samochodów o dywanikach': 'What drivers say about',
    'Mówią o nas': 'What customers say',
    'Więcej u nas na Facebooku': 'Follow us on Facebook',
    '- Czy dywaniki na pewno będą pasować?': '- Will the mats definitely fit?',
    'Tak, nasze dywaniki EVA są projektowane specjalnie dla każdej marki, modelu i wersji samochodu, pokrywając całą powierzchnię podłogi i zabezpieczając także miejsca, których nie zakrywają gumowe i welurowe dywaniki.': 'Yes. Our EVA mats are designed for each specific make, model and vehicle version, covering the floor and protecting areas that rubber and velour mats often leave exposed.',
    '- Co to jest dywanik na tunel?': '- What is a centre-tunnel mat?',
    'Dywaniki EVA zakrywają do 98% podłogi, w tym tunel środkowy, co zapewnia maksymalną ochronę.': 'EVAMATS sets can cover up to 98% of the floor, including the centre tunnel, for maximum protection.',
    '- Czy podpietka jest zamontowana do dywanika kierowcy?': '- Is the heel pad attached to the driver’s mat?',
    'Nie, podpietka jest dostarczana osobno, aby można ją było dostosować do własnych preferencji.': 'No. The heel pad is supplied separately so you can position it to suit your preference.',
    '- Co to jest materiał EVA?': '- What is EVA material?',
    'To pianka o grubości 10 mm, zatrzymująca brud i wodę na powierzchni dywanika, zapobiegając ich przedostawaniu się pod spód.': 'It is a 10 mm cellular foam that traps dirt and water inside the mat instead of letting them reach the floor underneath.',
    '- Czym różni się komplet 3D od 3D z rantami?': '- What is the difference between 3D mats with and without raised edges?',
    'Komplet 3D z rantami dodatkowo chroni boczną tapicerkę podłogi, zapewniając lepsze przyleganie.': 'The version with raised edges also protects the sides of the footwell and follows the floor more closely.',
    '- Jak długo wytrzymują dywaniki?': '- How long do the mats last?',
    'Dzięki trwałemu materiałowi EVA dywaniki służą od 5 do 7 lat bez oznak zużycia': 'Thanks to durable EVA material, the mats can last five to seven years without visible signs of wear.',
    '- Jak czyścić dywaniki EVA?': '- How do I clean EVA mats?',
    'Zanieczyszczenia nie przywierają do powierzchni dywanika. Wystarczy je wytrzepać lub, w przypadku mocnych zabrudzeń, umyć wodą pod ciśnieniem.': 'Dirt does not cling to the surface. Simply shake the mats out or, for heavier soiling, rinse them with pressurised water.',
    '- Czy dywaniki EVA nadają się na lato i zimę?': '- Are EVA mats suitable for summer and winter?',
    'Tak, są wodoodporne, bezzapachowe, odporne na temperaturę i idealne do całorocznego użytku.': 'Yes. They are waterproof, odour-free, temperature-resistant and suitable for year-round use.',
    '- Jaki jest czas realizacji?': '- What is the production time?',
    'Standardowy czas realizacji zamówienia wynosi obecnie 14 dni roboczych ze względu na  indywidualną, ręczną produkcję każdego kompletu. Dla specjalnych pojazdów, takich jak motorówki czy traktory, czas może wydłużyć się do 4-6 tygodni.': 'The current standard production time is 14 working days because every set is made individually by hand. For specialist vehicles such as motorboats or tractors, production may take four to six weeks.',
    '- Jaki jest sposób dostawy?': '- How are the mats delivered?',
    'Dywaniki wysytamy kurierem bezposrednio pod wskazany adres klienta. Dywaników nie wysytamy do paczkomatu ze wzgledów gabarytów produktu. Zalezy nam na tym aby dywaniki byty dostarczone w takiej formie w jakiej zostaty wykonane oraz nie poddac ich sktadaniu ani zatamywaniu co moze wptywac na dalsze losy dopasowania.': 'We send the mats by courier directly to the address provided. Their size means they cannot be delivered to a parcel locker. This allows them to arrive in the same shape in which they were made, without folding or creasing that could affect the fit.',

    // Gallery.
    'Galeria EVAMATS': 'EVAMATS Gallery',
    'Wybierz typ nadwozia': 'Choose a body type',
    'Wybierz Rodzaj Dywaników': 'Choose the mat type',
    'Wybierz rodzaj dywaników': 'Choose the mat type',
    'Mamy dla Ciebie jeszcze więcej do odkrycia!': 'There is even more for you to discover!',

    // Custom-order form.
    '1. Wybierz rok:': '1. Select the year:',
    '1. Wybierz rok, marka, model i typ nadwozia:': '1. Select the year, make, model and body type:',
    '2. Wybierz rodzaj i zestaw mat:': '2. Choose the mat type and set:',
    '3. Wybierz kształt i kolory:': '3. Choose the cell pattern and colours:',
    '4. Wybierz Marka, Model i Typ nadwozia:': '4. Enter the make, model and body type:',
    'Wybierz Marka, Model i Typ nadwozia:': 'Enter the make, model and body type:',
    'Podpiętki (opcjonalnie):': 'Heel pads (optional):',
    'Uwagi do zamówienia': 'Order notes',
    'Skrzynia biegów:': 'Transmission:',
    'Automatyczna': 'Automatic',
    'Manualna': 'Manual',
    'Marka samochodu: *': 'Vehicle make: *',
    'Model samochodu: *': 'Vehicle model: *',
    'Typ nadwozia: *': 'Body type: *',
    'SUV 5-osobowy': '5-seat SUV',
    'SUV 7-osobowy': '7-seat SUV',
    'Kombi': 'Station Wagon',
    'Kabriolet': 'Convertible',
    'Van kompaktowy': 'Compact Van',
    'Van dostawczy': 'Cargo Van',
    'Ciągnik': 'Tractor',
    'VAN': 'Van',
    'TIR': 'Truck',
    'Camper': 'Camper',
    'Other': 'Other',
    'Jak działa indywidualne zamówienie? 🚗': 'How does a custom order work? 🚗',
    'Skonfiguruj zestaw: Podaj dane auta, wybierz kolory oraz dodatki.': 'Configure your set: enter your vehicle details and choose the colours and extras.',
    'Wpłać zaliczkę: Na start płacisz tylko 100 zł (plus pełną kwotę za wybrane dodatki).': 'Pay a deposit: start with just 100 zł, plus the full price of any selected extras.',
    'Potwierdź szczegóły: Zadzwoni do Ciebie nasz konsultant. Po krótkiej rozmowie przekaże zamówienie do realizacji.': 'Confirm the details: our consultant will call you and, after a short conversation, send the order to production.',
    'Wybierz resztę płatności: Pozostałą część kwoty dopłacisz przelewem z góry lub gotówką/kartą u kuriera.': 'Choose how to pay the balance: by bank transfer in advance or by cash/card to the courier.',
    'Uwagi (Opisz wymiary, kształt podłogi lub załącz zdjęcie wnętrza pojazdu – to pomoże nam w idealnym dopasowaniu.)': 'Notes (describe the dimensions and floor shape, or attach an interior photo to help us achieve the best fit.)',
    'Na wymiar': 'Made to measure',
    'Zamów dywaniki do nietypowego pojazdu': 'Order mats for an unusual vehicle',
    'Łódź · samolot · quad · inne': 'Boat · aircraft · quad · other',

    // Outlet filters.
    'Filtry:': 'Filters:',
    'Typ nadwozia': 'Body type',
    'Rok produkcji': 'Year of manufacture',
    'Ciągnik siodłowy': 'Tractor Unit',
    'Coupe-Kabriolet': 'Coupe-Convertible',
    'Suv': 'SUV',
    'Sedan/Kombi': 'Sedan / Station Wagon',
    'Spycharka': 'Bulldozer',

    // Accessory titles and descriptions shown in cards and the cart editor.
    'Folia Ochronna - Ochraniacz Krawędzi Drzwi Uniwersalny': 'Universal Door Edge Protective Film',
    'Organizer Klasyczny M': 'Classic Trunk Organizer M',
    'Organizer XL': 'XL Trunk Organizer',
    'Organizer Klasyczny XL': 'Classic Trunk Organizer XL',
    'Organizer do bagażnika M 35/30 cm': 'Trunk Organizer M 35/30 cm',
    'Organizer do bagażnika XL 54/30 cm': 'Trunk Organizer XL 54/30 cm',
    'Organizer do bagażnika Klasyczny XL 48x33 cm': 'Classic XL Trunk Organizer 48 × 33 cm',
    'Organizer do bagażnika Klasyczny M 33x33 cm': 'Classic M Trunk Organizer 33 × 33 cm',
    'Organizer M': 'Trunk Organizer M',
    'Organizer luki na fotel samochodowy': 'Car Seat Gap Organizer',
    'Uniwersalny wieszak samochodowy': 'Universal Car Hanger',
    'Stylowe naklejki pod klamki – wzór carbon, zestaw 4 szt': 'Carbon-Look Door Handle Protectors — Set of 4',
    'Przezroczysta folia pod uchwyt drzwi auta – 4 szt.': 'Clear Car Door Handle Protective Film — Set of 4',
    'Samochodowy kosz na śmieci lub organizer na fotel': 'Car Rubbish Bin or Seat Organizer',
    'Uniwersalny organizer na Chusteczki do Samochodu': 'Universal Car Tissue Organizer',
    'Ochraniacz tapicerki pod fotelik samochodowy EVA': 'EVA Car Seat Protector',
    'Organizer do bagażnika z ekoskóry ZIP M – 30×30×50 cm': 'Eco-Leather Trunk Organizer ZIP M — 30 × 30 × 50 cm',
    'Organizer do bagażnika z ekoskóry ECO S – 30×30×35 cm': 'Eco-Leather Trunk Organizer ECO S — 30 × 30 × 35 cm',
    'Organizer do bagażnika z ekoskóry ECO M – 30×30×50 cm': 'Eco-Leather Trunk Organizer ECO M — 30 × 30 × 50 cm',
    'Organizer do bagażnika z ekoskóry ECO L – 30×30×65 cm': 'Eco-Leather Trunk Organizer ECO L — 30 × 30 × 65 cm',
    'Organizer do bagażnika z ekoskóry ECO ZIP L – 30×30×65 cm': 'Eco-Leather Trunk Organizer ECO ZIP L — 30 × 30 × 65 cm',
    'Organizer do bagażnika z ekoskóry ECO MultiOpen L – 30×30×65 cm': 'Eco-Leather Trunk Organizer ECO MultiOpen L — 30 × 30 × 65 cm',
    'Organizer do bagażnika z ekoskóry ECO XL – 30×30×80 cm': 'Eco-Leather Trunk Organizer ECO XL — 30 × 30 × 80 cm',
    'Organizer do bagażnika z ekoskóry ECO MultiOpen XL – 30×30×80 cm': 'Eco-Leather Trunk Organizer ECO MultiOpen XL — 30 × 30 × 80 cm',
    'Organizer do bagażnika z ekoskóry ECO XXL – 30×30×100 cm': 'Eco-Leather Trunk Organizer ECO XXL — 30 × 30 × 100 cm',
    'Organizer do bagażnika z ekoskóry ECO MultiOpen XXL – 30×30×90 cm': 'Eco-Leather Trunk Organizer ECO MultiOpen XXL — 30 × 30 × 90 cm',
    'Ochraniacz tapicerki EVA': 'EVA Seat Protector',
    'Czarna podkładka antypoślizgowa': 'Black Anti-Slip Mat',
    'Ściereczka z Mikrofibry do samochodu mała 40x40': 'Small Car Microfibre Cloth 40 × 40 cm',
    'Exclusive Premium Packaging (Ideal for a gift)': 'Exclusive Premium Packaging (Perfect for a gift)',

    // Footer and newsletter.
    'SKLEP': 'SHOP',
    'Sklep': 'Shop',
    'FIRMA': 'COMPANY',
    'Firma': 'Company',
    'POMOC': 'HELP',
    'Pomoc': 'Help',
    'KONTAKT': 'CONTACT',
    'Kontakt': 'Contact',
    'Zapisz się i odbierz 27 zł rabatu na pierwsze zamówienie': 'Subscribe and get 27 zł off your first order',
    'Zapisz się i odbierz': 'Subscribe and get',
    'Zapisz się do newslettera i odbierz': 'Subscribe to our newsletter and get',
    '27 zł rabatu': '27 zł off',
    '27 zł rabatu na pierwsze zakupy!': '27 zł off your first order!',
    'na pierwsze zamówienie': 'your first order',
    '£27 off': '27 zł off',
    'rabatu na pierwsze zamówienie': 'off your first order',
    'Promocje, nowości i porady o dywanikach EVA — raz w miesiącu': 'Offers, new products and EVA mat tips — once a month',
    'Twój adres e-mail': 'Your email address',
    'Zapisz się': 'Subscribe',
    'AKCEPTUJEMY PŁATNOŚCI': 'PAYMENT METHODS',
    'Akceptujemy płatności': 'Payment methods',
    'NASI PARTNERZY': 'OUR PARTNERS',
    'Nasi partnerzy': 'Our partners',
    'EVAMATS Dywaniki samochodowe': 'EVAMATS Car Mats',
    'Bardzo wysoka jakość dywaników;': 'Very high-quality car mats;',
    'Szybka dostawa;': 'Fast delivery;',
    'Idealne dopasowanie do auta.': 'A precise fit for the vehicle.',
    'ul. Strzelca 42,80-299 Gdańsk, Polska': 'ul. Strzelca 42, 80-299 Gdańsk, Poland',
    'Polska': 'Poland'
  };

  // EVM_PL_EN_FINAL_20260820_START
  Object.assign(EXACT,   {
      "Produkty": "Products",
      "Zalety produktu": "Product benefits",
      "Wybierz pojazd": "Select vehicle",
      "Znajdź model auta": "Find your car model",
      "Wybierz model": "Select model",
      "Wpisz markę...": "Enter make…",
      "Najpierw wybierz markę": "Select a make first",
      "Generacja": "Generation",
      "Najpierw wybierz model": "Select a model first",
      "Nadwozie": "Body type",
      "Najpierw wybierz generację": "Select a generation first",
      "Wybierz zestaw": "Choose a set",
      "Faktura ekoskóry": "Eco-leather finish",
      "Czarna, nić czarna": "Black with black stitching",
      "CZARNA, NIĆ CZARNA": "BLACK WITH BLACK STITCHING",
      "Np. dodatkowe informacje dla produkcji...": "e.g. additional production details…",
      "Dodaj do koszyka": "Add to cart",
      "Zamawiaj bez obaw.": "Shop with confidence.",
      "Ochrona kupującego dostępna w kolejnych krokach": "Buyer protection is available at the next steps.",
      "Wybierz kształt i kolory:": "Choose cell pattern and colours:",
      "Twój wybór": "Your selection",
      "Próbka wzoru i kolorów — nie jest to zdjęcie produktu": "Pattern and colour sample — not a product photo",
      "Próbka wzoru i kolorów — *Dywanik POGLĄDOWY dla wyboru koloru nie jest to zdjęcie produktu": "Pattern and colour preview — the mat shown is for colour selection only and is not a product photo",
      "Kolor materiału": "Material colour",
      "Kolor materialu": "Material colour",
      "KOLOR MATERIALU": "MATERIAL COLOUR",
      "Uwagi do zamówienia": "Order notes",
      "Uwagi do zamówienia (opcjonalnie)": "Order notes (optional)",
      "Opis": "Description",
      "(opcjonalnie)": "(optional)",
      "OPIS": "DESCRIPTION",
      "INSTRUKCJA REALIZACJI": "HOW TO REDEEM",
      "DOSTAWA I ZWROTY": "DELIVERY AND RETURNS",
      "Wycieraczka pod drzwi": "Door Mat",
      "Ociekacz do suszenia naczyń": "Dish Drying Mat",
      "Mata dla zwierząt uniwersalna": "Universal Pet Mat",
      "Mata do misek kostka": "Bone-Shaped Pet Bowl Mat",
      "Mata do misek kota": "Cat Bowl Mat",
      "Mata do misek pies": "Dog Bowl Mat",
      "Podpiętka EVAMATS": "EVAMATS Heel Pad",
      "Podpiętka Gumowa": "Rubber Heel Pad",
      "Romby": "Diamond",
      "ROMBY": "DIAMOND",
      "Plaster miodu": "Honeycomb",
      "PLASTER MIODU": "HONEYCOMB",
      "Kropla": "Droplet",
      "KROPLA": "DROPLET",
      "Czarny": "Black",
      "CZARNY": "BLACK",
      "Brązowy": "Brown",
      "BRĄZOWY": "BROWN",
      "Beżowy": "Beige",
      "BEŻOWY": "BEIGE",
      "Ciemnoszary": "Dark Grey",
      "CIEMNOSZARY": "DARK GREY",
      "Czerwony": "Red",
      "CZERWONY": "RED",
      "Niebieski": "Blue",
      "NIEBIESKI": "BLUE",
      "Biały": "White",
      "BIAŁY": "WHITE",
      "Szary": "Grey",
      "SZARY": "GREY",
      "Kawowy": "Coffee",
      "KAWOWY": "COFFEE",
      "Bordowy": "Maroon",
      "BORDOWY": "MAROON",
      "Pomarańczowy": "Orange",
      "POMARAŃCZOWY": "ORANGE",
      "Zielony": "Green",
      "ZIELONY": "GREEN",
      "Fioletowy": "Purple",
      "FIOLETOWY": "PURPLE",
      "Żółty": "Yellow",
      "ŻÓŁTY": "YELLOW",
      "Granatowy": "Navy Blue",
      "GRANATOWY": "NAVY BLUE",
      "Jasnoszary": "Light Grey",
      "JASNOSZARY": "LIGHT GREY",
      "Jasnobeżowy": "Light Beige",
      "JASNOBEŻOWY": "LIGHT BEIGE",
      "Jasnozielony": "Light Green",
      "JASNOZIELONY": "LIGHT GREEN",
      "Kość słoniowa": "Ivory",
      "KOŚĆ SŁONIOWA": "IVORY",
      "Różowy": "Pink",
      "RÓŻOWY": "PINK",
      "Malinowy": "Raspberry",
      "MALINOWY": "RASPBERRY",
      "Miedziany": "Copper",
      "MIEDZIANY": "COPPER"
  });

  Object.assign(EXACT, {
    'Cena regularna': 'Regular price',
    'Cena sprzedaży': 'Sale price',
    '*Podgląd poglądowy — nie jest zdjęciem gotowego produktu. Dokładny kolor wybierasz poniżej.': '*Preview only — this is not a photo of the finished product. Choose the exact colour below.',
    '🛡️ Co to są podpiętki i dlaczego warto je dodać?': '🛡️ What are heel pads and why should you add one?',
    'Podpiętki': 'Heel pads',
    'to dodatkowe wzmocnienia montowane pod piętą kierowcy – dokładnie tam, gdzie najczęściej zużywa się dywanik. Chronią przed przetarciem, wydłużają żywotność maty i zwiększają komfort użytkowania.': 'are additional reinforcements fitted beneath the driver’s heel — exactly where the mat wears fastest. They protect it from abrasion, extend its service life and improve driving comfort.',
    'Rodzaje podpiętek:': 'Types of heel pad:',
    'Podpiętka gumowa': 'Rubber heel pad',
    '– solidna, antypoślizgowa, dostępna w dwóch wzorach:': '— durable and non-slip, available in two patterns:',
    'Podpiętka z materiału EVA': 'EVA heel pad',
    '– wykonana z tego samego materiału i w tym samym kolorze co dywanik, idealnie się komponuje.': '— made from the same material and in the same colour as the mat for a seamless match.',
    'Podpiętka metalowa': 'Metal heel pad',
    '– wyjątkowo trwała, odporna na ekstremalne warunki.': '— exceptionally durable and resistant to demanding conditions.',
    '📸 Zobacz, jak to działa:': '📸 See how it works:',
    'Korzyści:': 'Benefits:',
    'Chroni dywanik przed szybkim zużyciem': 'Protects the mat from premature wear',
    'Poprawia przyczepność pięty do podłoża': 'Improves grip beneath the heel',
    'Zwiększa trwałość i estetykę zestawu': 'Extends the life of the set and keeps it looking neat',
    'Odporne na wilgoć': 'Moisture-resistant',
    'Zatrzymują brud': 'Trap dirt',
    'Uniwersalny krój': 'Universal fit',
    'Miękki materiał': 'Soft material',
    'Komfort i wyciszenie': 'Comfort and a quieter interior',
    'Wodoodporne i trwałe': 'Water-resistant and durable',
    'Ekskluzywny wygląd': 'Premium appearance'
  });
  // EVM_PL_EN_FINAL_20260820_END

  var PATTERNS = [
    [/^Brakuje\s+(.+?)\s+do darmowej dostawy$/i, '$1 left to qualify for free delivery'],
    [/^Jeszcze\s+(\d+)\s+do wyboru$/i, '$1 more to choose'],
    [/^(\d+)\s+pozycja$/i, '$1 item'],
    [/^(\d+)\s+pozycje$/i, '$1 items'],
    [/^(\d+)\s+pozycji$/i, '$1 items'],
    [/^Wykrój przygotowany 1:1 pod\s+(.+?)\.$/i, 'A 1:1 pattern tailored to $1.'],
    [/^Przód \+ Tył\s*\/\s*(.+)$/i, 'Front + rear / $1'],
    [/^Przód \+ tył\s*\/\s*(.+)$/i, 'Front + rear / $1'],
    [/^KROK\s+(\d+)\s+Z\s+(\d+)$/i, 'STEP $1 OF $2'],
    [/^Krok\s+(\d+)\s*\/\s*(\d+)$/i, 'STEP $1 OF $2'],
    [/^Krok\s+(\d+)$/i, 'Step $1'],
    [/^Załaduj obraz do widoku galerii$/i, 'Load image in gallery view'],
    [/^Załaduj obraz\s+(\d+)\s+do widoku galerii$/i, 'Load image $1 in gallery view'],
    [/^Odtwórz film\s+(\d+)\s+w widoku galerii$/i, 'Play video $1 in gallery view'],
    [/^Oszczędzasz\s+(.+)$/i, 'You save $1'],
    [/^Krople\s*\(\+?\s*([\d,.]+)\s*zł\)$/i, 'Droplets (+$1 zł)'],
    [/^Kształt komórek\s*[—-]\s*Krople$/i, 'Cell pattern — Droplets'],
    [/^Dywanik pasażera$/i, "Passenger's mat"],
    [/^Mata do bagażnika wersja benzyna$/i, 'Trunk mat — petrol version'],
    [/^Duża mata do bagażnika$/i, 'Large trunk mat'],
    [/^Bagażnik$/i, 'Trunk mat'],
    [/^Bagażnik MAŁY$/i, 'Small trunk mat'],
    [/^Bagażnik DUŻY$/i, 'Large trunk mat'],
    [/^1\s+rząd$/i, '1 row'],
    [/^1\s+rząd\s*\+\s*bagażnik$/i, '1 row + trunk mat'],
    [/^2\s+rząd$/i, 'Second row'],
    [/^2\s+rzędy$/i, '2 rows'],
    [/^2\s+rzędy\s*\+\s*bagażnik$/i, '2 rows + trunk mat'],
    [/^2\s+rzędy\s*\+\s*duży bagażnik$/i, '2 rows + large trunk mat'],
    [/^3\s+rzędy$/i, '3 rows'],
    [/^3\s+rzędy\s*\+\s*bagażnik MAŁY$/i, '3 rows + small trunk mat'],
    [/^3\s+rzędy\s*\+\s*bagażnik DUŻY\s*\(całe auto\)$/i, '3 rows + large trunk mat (whole vehicle)'],
    [/^3\s+rzędy\s*\+\s*bagażnik DUŻY$/i, '3 rows + large trunk mat'],
    [/^3\s+rzędy\s*\+\s*2\s+bagażniki\s+mały\s+i\s+duży\s*\(całe auto\)$/i, '3 rows + small and large trunk mats (whole vehicle)'],
    [/^Przód\s+bez\s+tunelu$/i, 'Front without tunnel'],
    [/^Przód\s+z\s+tunelem$/i, 'Front with tunnel'],
    [/^Przód\s*\+\s*bagażnik$/i, 'Front + trunk mat'],
    [/^Przód\s*\+\s*tył\s*\+\s*duży\s+bagażnik$/i, 'Front + rear + large trunk mat'],
    [/^Przód\s*\+\s*tył\s*\+\s*3\s+rząd$/i, 'Front + rear + third row'],
    [/^Przód\s*\+\s*tył\s*\+\s*3\s+rząd\s*\+\s*mały\s+bagażnik$/i, 'Front + rear + third row + small trunk mat'],
    [/^Przód\s*\+\s*tył\s*\+\s*3\s+rząd\s*\+\s*duży\s+bagażnik$/i, 'Front + rear + third row + large trunk mat'],
    [/^Przód\s*\+\s*tył\s*\+\s*3\s+bagażniki\s*\(1\s+duży\s+i\s+2\s+małych\s+z\s+przodu\s+i\s+z\s+tyłu\)$/i, 'Front + rear + 3 trunk mats (1 large + 2 small)'],
    [/^2\s+rzędy\s*\+\s*3\s+bagażniki\s*\(1\s+duży\s+i\s+2\s+małych\s+z\s+przodu\s+i\s+z\s+tyłu\)$/i, '2 rows + 3 trunk mats (1 large + 2 small)'],
    [/^Przód\s*\+\s*tył\s*\+\s*3\s+rząd\s*\+\s*3\s+bagażniki\s*\(1\s+mały\s+bagażnik\s+i\s+2\s+małych\s+z\s+przodu\s+i\s+z\s+tyłu\)$/i, 'Front + rear + third row + 3 small trunk mats'],
    [/^Przód\s*\+\s*tył\s*\+\s*3\s+rząd\s*\+\s*3\s+bagażniki\s*\(1\s+duży\s+bagażnik\s+i\s+2\s+małych\s+z\s+przodu\s+i\s+z\s+tyłu\)$/i, 'Front + rear + third row + 3 trunk mats (1 large + 2 small)'],
    [/^(.+?)\s+\(opcjonalnie\)$/i, '$1 (optional)'],
    [/^(Fitted\s*\([^)]*?)\s+Zł\)$/i, '$1 zł)'],
    [/^([+−-]?[\d,.]+\s*zł)\s+względem obecnej$/i, '$1 vs current configuration'],
    [/^Brakuje jeszcze\s+(.+?)\s+do darmowej wysyłki$/i, '$1 left to qualify for free delivery'],
    [/^(\d+)\s+rzędy\s*\+\s*2\s+Bagażniki\s*\(Duży\s*\|\s*Mały\)$/i, '$1 rows + 2 trunks (large | small)'],
    [/^(.+?)\s+Ideal for a gift(.*?)$/i, '$1Perfect for a gift$2']
  ];

  function translated(value) {
    if (typeof value !== 'string') return value;
    var match = value.match(/^(\s*)([\s\S]*?)(\s*)$/);
    var lead = match[1];
    var core = match[2];
    var tail = match[3];
    if (!core) return value;
    if (Object.prototype.hasOwnProperty.call(EXACT, core)) return lead + EXACT[core] + tail;
    var joinedParts = core.split(/\s*·\s*/);
    if (joinedParts.length > 1) {
      var localizedParts = joinedParts.map(function (part) { return translated(part).trim(); });
      if (localizedParts.some(function (part, index) { return part !== joinedParts[index]; })) {
        return lead + localizedParts.join(' · ') + tail;
      }
    }
    var normalizedCore = core.replace(/\s+/g, ' ');
    if (Object.prototype.hasOwnProperty.call(EXACT, normalizedCore)) return lead + EXACT[normalizedCore] + tail;
    for (var i = 0; i < PATTERNS.length; i += 1) {
      if (PATTERNS[i][0].test(core)) return lead + core.replace(PATTERNS[i][0], PATTERNS[i][1]) + tail;
    }
    return value;
  }

  function translateTextNode(node) {
    var parent = node.parentElement;
    if (!parent || /^(SCRIPT|STYLE|NOSCRIPT|TEMPLATE|SVG)$/i.test(parent.tagName)) return;
    var next = translated(node.nodeValue);
    if (next !== node.nodeValue) node.nodeValue = next;
  }

  function translateAttributes(el) {
    ['aria-label', 'title', 'placeholder', 'data-label', 'alt'].forEach(function (name) {
      if (!el.hasAttribute || !el.hasAttribute(name)) return;
      var current = el.getAttribute(name);
      var next = translated(current);
      if (next !== current) el.setAttribute(name, next);
    });
  }

  function cleanCollectionLabel(element) {
    if (!element.matches || !element.matches('.collection-color_block__material, .sidebar-color_block__material')) return;
    var value = (element.textContent || '').trim();
    var cleaned = value
      .replace(/^Custom-fit EVA car mats for\s+/i, '')
      .replace(/^EVA car mats for\s+/i, '')
      .replace(/^Car mats for\s+/i, '')
      .replace(/^Car Accessories\s+/i, '');
    if (cleaned && cleaned !== value) element.textContent = cleaned;
  }

  function localizeBreadcrumbLinks() {
    document.querySelectorAll('.tt-breadcrumb a[href]').forEach(function (link) {
      var url;
      try {
        url = new URL(link.href, window.location.origin);
      } catch (error) {
        return;
      }
      if (url.origin !== window.location.origin || /^\/en(?:\/|$)/i.test(url.pathname)) return;
      url.pathname = url.pathname === '/' ? '/en' : '/en' + url.pathname;
      link.href = url.pathname + url.search + url.hash;
    });
  }

  function localizeCrossSellLinks() {
    document.querySelectorAll('.evmx-card[href]').forEach(function (link) {
      var url;
      try {
        url = new URL(link.href, window.location.origin);
      } catch (error) {
        return;
      }
      if (url.origin !== window.location.origin || /^\/en(?:\/|$)/i.test(url.pathname)) return;
      url.pathname = url.pathname === '/' ? '/en' : '/en' + url.pathname;
      link.href = url.pathname + url.search + url.hash;
    });
  }

  function localizeTrustedShopsProtection() {
    var selector = 'etrusted-widget[data-etrusted-widget-id="wdg-72c723c3-1f83-44e9-89c0-48433e3244a7"]';
    document.querySelectorAll(selector).forEach(function (widget) {
      if (widget.getAttribute('data-evm-en-replaced') === 'true') return;
      widget.setAttribute('data-evm-en-replaced', 'true');
      widget.hidden = true;
      widget.style.setProperty('display', 'none', 'important');

      var card = document.createElement('a');
      card.className = 'evm-en-buyer-protection';
      card.href = 'https://www.trustedshops.pl/opinia/info_X6AD02EC93DE5ECB103DFB6AE6C1E39BA.html';
      card.target = '_blank';
      card.rel = 'noopener noreferrer';
      card.setAttribute('aria-label', 'Secure shopping with Trusted Shops. Learn more about buyer protection.');
      card.innerHTML = '<span class="evm-en-buyer-protection__icon" aria-hidden="true">'
        + '<svg viewBox="0 0 28 32" fill="none"><path d="M14 1.8 25 6v8.2c0 7.3-4.5 13.2-11 16-6.5-2.8-11-8.7-11-16V6l11-4.2Z" fill="currentColor"/><path d="m8.8 15.4 3.2 3.2 7.2-7.4" stroke="#ffdc0f" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>'
        + '</span>'
        + '<span class="evm-en-buyer-protection__copy">'
        + '<span class="evm-en-buyer-protection__brand">TRUSTED SHOPS</span>'
        + '<strong>Shop securely with buyer protection.</strong>'
        + '<small>Optional buyer protection is available during checkout.</small>'
        + '</span>'
        + '<span class="evm-en-buyer-protection__arrow" aria-hidden="true">→</span>';
      widget.insertAdjacentElement('afterend', card);
    });

    if (document.getElementById('evm-en-buyer-protection-style')) return;
    var style = document.createElement('style');
    style.id = 'evm-en-buyer-protection-style';
    style.textContent = '.evm-en-buyer-protection{position:relative;display:grid;grid-template-columns:48px minmax(0,1fr) 24px;align-items:center;gap:14px;margin:16px 0;padding:16px 18px;border:1px solid rgba(255,255,255,.1);border-radius:18px;background:linear-gradient(135deg,#fff 0%,#f4f5f7 100%);box-shadow:0 14px 34px rgba(0,0,0,.16);color:#111318;text-decoration:none;line-height:1.2;overflow:hidden;transition:transform .2s ease,box-shadow .2s ease}'
      + '.evm-en-buyer-protection:before{content:"";position:absolute;inset:0 auto 0 0;width:5px;background:#ffdc0f}'
      + '.evm-en-buyer-protection:hover{transform:translateY(-1px);box-shadow:0 18px 42px rgba(0,0,0,.22)}'
      + '.evm-en-buyer-protection__icon{display:grid;place-items:center;width:48px;height:48px;border-radius:14px;background:#ffdc0f;color:#111318}'
      + '.evm-en-buyer-protection__icon svg{display:block;width:28px;height:32px}'
      + '.evm-en-buyer-protection__copy{min-width:0}'
      + '.evm-en-buyer-protection__brand{display:block;margin-bottom:4px;font-size:10px;font-weight:800;letter-spacing:.13em;color:#5d6169}'
      + '.evm-en-buyer-protection strong{display:block;font-size:15px;font-weight:800;letter-spacing:-.01em}'
      + '.evm-en-buyer-protection small{display:block;margin-top:4px;color:#686d76;font-size:12px;line-height:1.35}'
      + '.evm-en-buyer-protection__arrow{font-size:21px;font-weight:700;transition:transform .2s ease}'
      + '.evm-en-buyer-protection:hover .evm-en-buyer-protection__arrow{transform:translateX(3px)}'
      + '@media(max-width:480px){.evm-en-buyer-protection{grid-template-columns:42px minmax(0,1fr) 18px;gap:11px;padding:14px 13px 14px 16px;border-radius:15px}.evm-en-buyer-protection__icon{width:42px;height:42px;border-radius:12px}.evm-en-buyer-protection strong{font-size:13px}.evm-en-buyer-protection small{font-size:11px}}';
    document.head.appendChild(style);
  }

  function localizeHeelPadPopup() {
    var popup = document.querySelector('#popupOverlayUpsellVideo .popup-content');
    if (!popup) return;
    Array.prototype.forEach.call(popup.querySelectorAll('li'), function (item) {
      Array.prototype.forEach.call(item.childNodes || [], function (node) {
        if (node.nodeType === 3 && node.nodeValue.trim() === 'i') {
          node.nodeValue = node.nodeValue.replace(/\bi\b/, 'and');
        }
      });
    });
  }

  function translateRoot(root) {
    if (!root) return;
    if (root.nodeType === 3) {
      translateTextNode(root);
      return;
    }
    if (root.nodeType !== 1 && root.nodeType !== 9 && root.nodeType !== 11) return;
    var elements = [];
    if (root.nodeType === 1) elements.push(root);
    if (root.querySelectorAll) elements = elements.concat(Array.prototype.slice.call(root.querySelectorAll('*')));
    elements.forEach(function (element) {
      translateAttributes(element);
      Array.prototype.forEach.call(element.childNodes || [], function (child) {
        if (child.nodeType === 3) translateTextNode(child);
      });
      cleanCollectionLabel(element);
    });
    var policyParagraphs = root.querySelectorAll ? root.querySelectorAll('p') : [];
    Array.prototype.forEach.call(policyParagraphs, function (paragraph) {
      if (!paragraph.querySelector('a[href*="privacy-policy"]') || !paragraph.querySelector('a[href*="terms-of-service"]')) return;
      Array.prototype.forEach.call(paragraph.childNodes || [], function (child) {
        if (child.nodeType === 3) child.nodeValue = child.nodeValue.replace(/\bi\b/, 'and');
      });
    });
    var productLede = root.querySelector ? root.querySelector('.evm-opis-lede') : null;
    if (productLede && productLede.getAttribute('data-evm-en-copy') !== 'done') {
      productLede.innerHTML = 'Original <b>EVAMATS</b> car mats provide modern protection for your vehicle interior. Each pattern is tailored to a specific model, the cellular structure traps mud, sand and water, and the edge trim follows and protects every contour.';
      productLede.setAttribute('data-evm-en-copy', 'done');
    }
    var comparisonHeading = Array.prototype.find.call(root.querySelectorAll ? root.querySelectorAll('h2') : [], function (heading) {
      return /Why choose mats\s*EVAMATS\?/i.test(heading.textContent || '');
    });
    if (comparisonHeading && comparisonHeading.getAttribute('data-evm-en-copy') !== 'done') {
      var accent = comparisonHeading.querySelector('span');
      if (accent) {
        Array.prototype.slice.call(comparisonHeading.childNodes).forEach(function (child) {
          if (child !== accent) comparisonHeading.removeChild(child);
        });
        comparisonHeading.insertBefore(document.createTextNode('Why choose '), accent);
        accent.textContent = 'EVAMATS car mats?';
      } else {
        comparisonHeading.textContent = 'Why choose EVAMATS car mats?';
      }
      comparisonHeading.setAttribute('data-evm-en-copy', 'done');
    }
  }

  var SECTION_MEDIA = {
    'image_with_textarea_P7DUVw': {
      '5_-_1_red_1.webp': '/cdn/shop/files/evamats-en-footrest.webp',
      '5_-_1_1.webp': '/cdn/shop/files/evamats-en-3d-footrest.webp'
    },
    'image_with_text_apL3ta': {
      '5_-_1_red_1.webp': '/cdn/shop/files/evamats-en-footrest.webp',
      '5_-_1_1.webp': '/cdn/shop/files/evamats-en-3d-footrest.webp'
    },
    'image_with_text_BCf4Pz': {'5-_2_red_1.webp': '/cdn/shop/files/evamats-en-perfect-fit.webp'},
    'image_with_text_UBwFkQ': {'7.webp': '/cdn/shop/files/evamats-en-raised-edges-7cm.webp'},
    'image_with_text_tWVPE8': {'5925cb22be9a4d3b185d58385efe28da.webp': '/cdn/shop/files/evamats-en-tunnel-cover.webp'},
    'image_with_text_6UfFWA': {'b58fc13bb3bd199839ba5737fed4d92b.webp': '/cdn/shop/files/evamats-en-edge-trim-thread.webp'},
    'image_with_text_nCGyQk': {'10.webp': '/cdn/shop/files/evamats-en-thickness-10mm.webp'},
    'image_with_text_3NrixM': {'7_b5ac776d-02b1-483a-abbb-d87c0746eda0.webp': '/cdn/shop/files/evamats-en-cells-7mm.webp'}
  };

  var SECTION_MEDIA_REMOVE = {
    'image_with_text_tWVPE8': ['5-_5_red_7a86d3c4-9420-47d3-b6ae-63fa656dfcd9.webp'],
    'image_with_text_3NrixM': ['5-_8_red_788cfeb5-7582-487b-9501-636b96603256.webp']
  };

  var PRODUCT_COPY = {
    'image_with_text_apL3ta': {
      heading: '1. FOOTREST — EXTRA PROTECTION UNDER THE PEDALS AND SEAT',
      html: '<p>✔ The specially designed footrest protects the areas most exposed to wear, including the left-foot rest area.</p><p>✔ Its precise fit follows the shape of the vehicle, improving driving comfort and the appearance of the interior.</p><p>⚠️ <strong>Please note:</strong> the 3D version with a footrest is not available for every model.</p><p>Please check the <strong>main product image</strong>, which shows an example of how the mats look for this vehicle.</p>'
    },
    'image_with_text_BCf4Pz': {
      heading: '2. PRECISE ALONG EVERY CONTOUR',
      html: '<p>✔ EVAMATS car mats are made with exceptional precision and follow every contour to provide maximum floor protection.</p><p>✔ The matte black finish and elegant edge trim complement a modern vehicle interior.</p>'
    },
    'image_with_text_UBwFkQ': {
      heading: '3. 3D MATS WITH EDGES UP TO 7 CM',
      html: '<p>✔ Raised edges up to 7 cm high effectively contain dirt, water and mud.</p><p>✔ The cellular structure prevents spills from spreading and makes the interior easier to keep clean.</p>'
    },
    'image_with_text_jgUTWj': {
      heading: '4. ORIGINAL FASTENERS FOR EVERY CAR BRAND',
      html: '<p>✔ EVAMATS car mats use a dedicated fastening system that prevents them from shifting.</p><p>✔ We support fasteners used by different car brands, from classic clips to BMW hook-and-loop fittings.</p>'
    },
    'image_with_text_tWVPE8': {
      heading: '5. CENTRE-TUNNEL COVER — PRECISE FIT WITH HOOK-AND-LOOP FASTENERS',
      html: '<p>✔ Hook-and-loop fasteners keep the centre-tunnel cover secure while driving.</p><p>✔ This solution protects the centre section of the floor from dirt and moisture.</p>'
    },
    'image_with_text_HwwdVX': {
      heading: '6. FASTENERS IN EVERY CORNER — SECURE STABILITY',
      html: '<p>✔ Additional corner fasteners keep the mats securely in place.</p><p>✔ This improves driving safety and helps extend the life of the product.</p>'
    },
    'image_with_text_6UfFWA': {
      heading: '7. DURABLE THREAD AND EDGE TRIM',
      html: '<p>✔ Carefully finished, high-quality edge trim resists abrasion and retains its elegant appearance.</p><p>✔ Reinforced thread provides lasting durability, even in demanding conditions.</p>'
    },
    'image_with_text_nCGyQk': {
      heading: '8. 10 MM THICKNESS — BETTER SOUND INSULATION',
      html: '<p>✔ EVAMATS car mats are 10 mm thick, helping reduce noise and vibration for greater driving comfort.</p><p>✔ Their soft yet durable structure is comfortable for both the driver and passengers.</p>'
    },
    'image_with_text_3NrixM': {
      heading: '9. 7 MM CELLULAR STRUCTURE — INNOVATIVE TECHNOLOGY',
      html: '<p>✔ EVAMATS car mats are available with two distinctive cell patterns: honeycomb or diamond.</p><p>✔ The 7 mm deep cells trap water, mud and other dirt, helping keep your vehicle interior clean.</p>'
    }
  };

  function replaceMedia() {
    Object.keys(SECTION_MEDIA).forEach(function (sectionKey) {
      var section = document.querySelector('[id*="' + sectionKey + '"]');
      if (!section) return;
      var mapping = SECTION_MEDIA[sectionKey];
      var filenamesToRemove = SECTION_MEDIA_REMOVE[sectionKey] || [];
      section.querySelectorAll('img, source').forEach(function (media) {
        var candidates = [media.getAttribute('src'), media.getAttribute('srcset'), media.getAttribute('data-src'), media.getAttribute('data-srcset')].filter(Boolean);
        if (filenamesToRemove.some(function (filename) {
          return candidates.some(function (value) { return value.indexOf(filename) !== -1; });
        })) media.remove();
      });
      var mediaContainer = section.querySelector('.image-with-text__media');
      if (mediaContainer && mediaContainer.querySelectorAll('img').length <= 1) {
        mediaContainer.classList.remove('image-with-text__media--two_images');
      }
      section.querySelectorAll('img, source').forEach(function (media) {
        var candidates = [media.getAttribute('src'), media.getAttribute('srcset'), media.getAttribute('data-src'), media.getAttribute('data-srcset')].filter(Boolean);
        Object.keys(mapping).some(function (filename) {
          if (!candidates.some(function (value) { return value.indexOf(filename) !== -1; })) return false;
          var url = mapping[filename];
          if (media.tagName === 'IMG') media.setAttribute('src', url);
          media.setAttribute('srcset', url);
          if (media.hasAttribute('data-src')) media.setAttribute('data-src', url);
          if (media.hasAttribute('data-srcset')) media.setAttribute('data-srcset', url);
          return true;
        });
      });
      var copy = PRODUCT_COPY[sectionKey];
      if (copy && section.getAttribute('data-evm-en-copy') !== 'done') {
        var heading = section.querySelector('h1, h2, h3');
        var richText = section.querySelector('.image-with-text__text.rte, .rte');
        if (heading) heading.textContent = copy.heading;
        if (richText) richText.innerHTML = copy.html;
        section.setAttribute('data-evm-en-copy', 'done');
      }
    });
  }

  function applyDocumentMetadata() {
    if (/^Twój koszyk(?: zakupów)?\b/i.test(document.title)) {
      document.title = document.title.replace(/^Twój koszyk(?: zakupów)?\b/i, 'Your cart');
    }
    if (/^Dywaniki samochodowe na indywidualne zamówienie\b/i.test(document.title)) {
      document.title = document.title.replace(/^Dywaniki samochodowe na indywidualne zamówienie\b/i, 'Custom-Made Car Mats');
    }
  }

  function hidePolishReviewWidgets() {
    document.querySelectorAll('.reputon-google-reviews-widget').forEach(function (widget) {
      var section = widget.closest('[id^="shopify-section-"]');
      var target = section || widget;
      target.hidden = true;
      target.style.setProperty('display', 'none', 'important');
      target.setAttribute('data-evm-en-reviews-hidden', 'true');
    });
  }

  var scheduled = false;
  var requestFrame = window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : function (callback) { return window.setTimeout(callback, 16); };
  function scheduleFullPass() {
    if (scheduled) return;
    scheduled = true;
    requestFrame(function () {
      scheduled = false;
      translateRoot(document.body);
      replaceMedia();
      applyDocumentMetadata();
      hidePolishReviewWidgets();
      localizeBreadcrumbLinks();
      localizeCrossSellLinks();
      localizeTrustedShopsProtection();
      localizeHeelPadPopup();
    });
  }

  function start() {
    translateRoot(document.body);
    replaceMedia();
    applyDocumentMetadata();
    hidePolishReviewWidgets();
    localizeBreadcrumbLinks();
    localizeCrossSellLinks();
    localizeTrustedShopsProtection();
    localizeHeelPadPopup();
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'characterData') translateTextNode(mutation.target);
        mutation.addedNodes.forEach(translateRoot);
      });
      scheduleFullPass();
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
    window.addEventListener('pageshow', scheduleFullPass);
    document.addEventListener('shopify:section:load', scheduleFullPass);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
